var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mascotas",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220,
    height: 276.411,
    viewBox: "0 0 220 276.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #471936;\n        stroke: #282d33;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-1",
    width: 220,
    height: 276.411
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M218.471,94.664,197.665,55.4a25.582,25.582,0,0,0-22.657-13.63H117.637V18.125a18.125,18.125,0,0,0-36.249,0V41.767H10.934A10.946,10.946,0,0,0,0,52.7v97.789a10.944,10.944,0,0,0,10.934,10.931H81.388v82.95H37.122a8.859,8.859,0,0,0-8.849,8.849v14.347a8.861,8.861,0,0,0,8.849,8.849H161.9a8.863,8.863,0,0,0,8.849-8.849V253.218a8.861,8.861,0,0,0-8.849-8.849H117.637v-82.95h57.2a25.534,25.534,0,0,0,22.8-13.915l20.911-40.677a13.159,13.159,0,0,0-.079-12.163M92.689,18.125a6.823,6.823,0,0,1,13.647,0V41.767H92.689Zm22.5,237.546H159.45v9.442H39.575V255.67H83.84a8.861,8.861,0,0,0,8.849-8.849v-85.4h13.647v85.4a8.859,8.859,0,0,0,8.849,8.849M208.5,101.662l-20.9,40.674a14.287,14.287,0,0,1-12.754,7.781H11.3V53.069H175.009a14.3,14.3,0,0,1,12.669,7.623l20.806,39.264a1.84,1.84,0,0,1,.014,1.707",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M44.423,43.14a8.588,8.588,0,0,0,8.586-8.586V30.259a8.586,8.586,0,1,0-17.173,0v4.295a8.588,8.588,0,0,0,8.586,8.586",
    transform: "translate(65.416 39.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M35.305,43.14a8.586,8.586,0,0,0,8.586-8.586V30.259a8.586,8.586,0,0,0-17.173,0v4.295a8.588,8.588,0,0,0,8.586,8.586",
    transform: "translate(48.772 39.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M50.5,29.271a8.586,8.586,0,0,0-8.586,8.586v4.295a8.586,8.586,0,1,0,17.173,0V37.857A8.588,8.588,0,0,0,50.5,29.271",
    transform: "translate(76.51 53.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-1",
    d: "M37.814,42.152V37.857a8.586,8.586,0,1,0-17.173,0v4.295a8.586,8.586,0,0,0,17.173,0",
    transform: "translate(37.677 53.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M62.783,37.772h0a12.752,12.752,0,0,0-20.3,0l-15.6,20.5A12.753,12.753,0,0,0,37.033,78.749h31.2a12.749,12.749,0,0,0,10.146-20.47Z",
    transform: "translate(44.324 59.764)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotas);
export default __webpack_public_path__ + "static/media/Mascotas.187870a3b1ce9749b79f0360bbbf9ba3.svg";
export { ForwardRef as ReactComponent };